module.exports = __webpack_public_path__ + "img/-LV4rU6_Fmv5oPmRsviu.7c09f7a3.jpg";